import { DatesRangeFilter } from '@/shared'

import style from './DatesRange.module.scss'

interface IProps {
    startDate: string | null
    endDate: string | null
    onSetStartDate: (date: string | null) => void
    onSetEndDate: (date: string | null) => void
}

export const DatesRange = (props: IProps) => {
    const { endDate, startDate, onSetStartDate, onSetEndDate } = props
    return (
        <div className={style.container}>
            <div className={style.dateRangePickerContainer}>
                <DatesRangeFilter
                    startDate={startDate}
                    endDate={endDate}
                    onSetStartDate={onSetStartDate}
                    onSetEndDate={onSetEndDate}
                />
            </div>
        </div>
    )
}
